export default "__VITE_ASSET__CRQ0VXce__"